module.exports = __webpack_public_path__ + "img/12.999b502d.jpg";